export const isFirmwareTypeId = (compTypeId) => {
  return compTypeId === 1;
};

export const isPatternTypeId = (compTypeId) => {
  return compTypeId === 2;
};

export const isImageTypeId = (compTypeId) => {
  return compTypeId === 3;
};

export const isDocumentId = (compTypeId) => {
  return compTypeId === 4;
};

export const getCompTypeCategory = (compId) => {
  if (compId === "acus.dpi.ptn" || compId === "egone.dpi.ptn") {
    return "SDP Pattern";
  } else if (
    compId === "dpi.ptn.ipsp.t" ||
    compId === "dpi.ptn.prov2.t" ||
    compId === "dpi.ptn.t" ||
    compId === "dpi.ptn.stdv2.t" ||
    compId === "dpi.ptn.ipsle.t" ||
    compId === "dpi.ptn.lev2.t"
  ) {
    return "IPS Pattern";
  } else if (compId === "av.ptn.t.patch" || compId === "av.ptn.t") {
    return "AV Pattern";
  }
};

export const isEdgeV2 = (compId, version) => {
  if (
    compId === "ipsp.fw.t01" ||
    compId === "ips.fw.g02" ||
    compId === "ipsle.fw.t01" ||
    compId === "ief.fw.t01"
  ) {
    const re = new RegExp("^.*(\\d+)\\.(\\d+)\\.(\\d+)$");
    const matchResult = re.exec(version);
    if (!matchResult) {
      return false;
    }
    const majorVersion = matchResult.length >= 2 ? matchResult[1] : 0;
    if (majorVersion <= 1) {
      return false;
    } else if (majorVersion > 1) {
      return true;
    }
    return true;
  } else if (
    compId === "ips.fw.t03" ||
    compId === "dpi.ptn.prov2.t" ||
    compId === "dpi.ptn.stdv2.t" ||
    compId === "dpi.ptn.lev2.t" ||
    compId === "av.ptn.t" ||
    compId === "av.ptn.t.patch" ||
    compId === "egone.fw" ||
    compId === "egone.fw.patch" ||
    compId === "egone.dpi.ptn" ||
    compId === "edgeone.ova" ||
    compId === "edgeone.qcow2" ||
    compId === "edgeone.vhdx" ||
    compId === "egone.doc.ova.qsg" ||
    compId === "egone.doc.qcow2.qsg" ||
    compId === "egone.doc.vhdx.qsg" ||
    compId === "egone.doc.ag" ||
    compId === "egone.doc.api" ||
    compId === "edgeone.releasenote" ||
    compId === "ips.releasenote" ||
    compId === "ips.g02.doc.qsg" ||
    compId === "ips.g02.doc.ag" ||
    compId === "ips.g02.doc.api" ||
    compId === "ips.g02.doc.cli" ||
    compId === "ips.t03.doc.qsg" ||
    compId === "ips.t03.doc.ag" ||
    compId === "ips.t03.doc.api" ||
    compId === "ips.t03.doc.cli"
  ) {
    return true;
  }
};
